// Every row lays its fields on the same two 150px columns, so their edges line up.
const columns = {
  display: 'flex',
  gap: 14,
  '& > *': {
    flex: 1,
    maxWidth: 150,
  },
};

const margin = '8px 0';

export default (theme) => ({
  closeButton: {
    right: '0!important',
  },
  dash: {
    position: 'absolute',
    top: 'calc(50% - .55em)',
    left: 'calc(50% - 13px)',
  },
  field: {
    margin,
  },
  fields: {
    ...columns,
    margin,
  },
  // Labelled columns stack below lg, as the Grid cells they replaced did.
  labelled: {
    ...columns,
    '& > $wide': {
      maxWidth: 'none',
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: 16,
    },
  },
  wide: {},
  formWrapper: {
    padding: '20px 16px 0',
    [theme.breakpoints.down('sm')]: {
      minWidth: 320,
    },
    [theme.breakpoints.up('md')]: {
      width: 700,
    },
  },
  error: {
    color: theme.palette.textColor.red,
    padding: '0 5px',
    fontSize: 11,
  },
  noPaddingError: {
    color: theme.palette.textColor.red,
    padding: 0,
    fontSize: 11,
  },
  primaryCheckbox: {
    color: theme.palette.textColor.primary,
    marginLeft: '-9px',
  },
  primaryAdd: {
    fontFamily: 'Poppins,Open Sans,sans-serif',
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    color: theme.palette.textColor.primary,
  },
});
